<template>
  <TopBarRss @click-rss="copyUrl" />
  <article class="content-page">
    <div class="top-54">
      <ContentHeader
        :img-src="headerImageSrc"
        :title="headerTitle"
        :date="date"
      />
      <div class="px-16 pt-16">
        <slot />
      </div>
      <ContentFooter @click-share="copyUrl" />
    </div>
  </article>
</template>

<script setup lang="ts">
const { copy } = useClipboard()
const { message } = useAlarm()
defineProps<{
  headerImageSrc: string
  headerTitle: string[]
  date: string
}>()
const copyUrl = () => {
  copy(window.location.href)
  message('info', 'URL이 복사되었어요.', false, true, 2000, 90, 'message-plain')
}
</script>
